export const BLOG_RESEARCH_AGENT_LISTING_SLUG = 'blog-research-agent';
export const BLOG_RESEARCH_AGENT_SUNSET_DATE_MS = Date.UTC(2026, 8, 7);

// Featured agents are: Customer agent, Prospecting agent, and Data Agent
export const FEATURED_AGENT_LISTING_IDS_QA = [1079084, 1139013, 1064150];
export const FEATURED_AGENT_LISTING_IDS_PROD = [30095295, 30109625, 30109615];
// Free access agents are: Customer agent, Prospecting agent, and Data Agent
export const FREE_ACCESS_AGENT_LISTING_IDS_QA = [1079084, 1139013, 1064150];
export const FREE_ACCESS_AGENT_LISTING_IDS_PROD = [30095295, 30109625, 30109615];